export default __webpack_public_path__ + "static/media/Emoji_Bar_Shocked.5e9979be.svg";